import { Box } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Layout } from '@roc/feature-app-core';
import { Paper } from '@roc/ui';
import { observer } from 'mobx-react';
import { PrincipalAmortizationGrid } from './principalAmortizationGrid';
import { usePrincipalAmortizationStore } from '../../hooks/usePrincipalAmortizationStore';
import { useParams } from 'react-router';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxWidth: '1400px',
  },
  paper: {
    boxShadow: 'none !important',
    border: '1px solid #cdcdcd',
    padding: '0px',
    borderRadius: '0 !important',
  },
}));

export const PrincipalAmortizationDashboard = observer(() => {
  const classes = useStyles();
  const { loanId } = useParams<{ loanId: string }>();
  const { principalAmortizationStore } = usePrincipalAmortizationStore();
  if (loanId) {
    principalAmortizationStore.setLoan({ loanId: loanId })
  }

  return (
    <Layout title="Principal Amortization Dashboard" containerClass={classes.container}>
      <Box display="flex" flexDirection="column" height="100%">
        <Box flex={1}>
          <Paper className={classes.paper}>
            <PrincipalAmortizationGrid />
          </Paper>
        </Box>
      </Box>
    </Layout>
  );
});
